import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";

// Lazy-load secondary routes/components to keep the home bundle small
const AdminLogin = lazy(() => import("./pages/AdminLogin.tsx"));
const AdminResetPassword = lazy(() => import("./pages/AdminResetPassword.tsx"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard.tsx"));
const NotFound = lazy(() => import("./pages/NotFound.tsx"));
const Dostepnosc = lazy(() => import("./pages/Dostepnosc.tsx"));
const PolitykaCookies = lazy(() => import("./pages/PolitykaCookies.tsx"));
const PolitykaPrywatnosci = lazy(() => import("./pages/PolitykaPrywatnosci.tsx"));
const KlauzulaRodoDzialajLokalnie = lazy(() => import("./pages/KlauzulaRodoDzialajLokalnie.tsx"));
const NewsArticle = lazy(() => import("./pages/NewsArticle.tsx"));
const NewsList = lazy(() => import("./pages/NewsList.tsx"));
const CookieBanner = lazy(() => import("./components/CookieBanner.tsx"));

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/aktualnosci" element={<NewsList />} />
              <Route path="/aktualnosci/:slug" element={<NewsArticle />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/reset-password" element={<AdminResetPassword />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/deklaracja-dostepnosci" element={<Dostepnosc />} />
              <Route path="/polityka-cookies" element={<PolitykaCookies />} />
              <Route path="/polityka-prywatnosci" element={<PolitykaPrywatnosci />} />
              <Route path="/dzialaj-lokalnie/klauzula-informacyjna-rodo" element={<KlauzulaRodoDzialajLokalnie />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <CookieBanner />
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
